import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PreviewIcon from '@mui/icons-material/Preview';
import { Badge, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { RolesTypes } from '../../../../../../config/roles';
import { AppRoutes } from '../../../../../../constants/appRoutes';
import { BecomeProStatuses } from '../../../../../../constants/becomeProStatuses';
import { InvestorStatuses } from '../../../../../../constants/investorStatus';
import { checkPermissions } from '../../../../../../helpers/checkPermissionHelper';
import { buildRegionizeRoute } from '../../../../../../helpers/regionRouteHelper';
import { InvestorService } from '../../../../../../views/investors/investorService';
import { TooltipWrapper } from '../../../../../formUtilities/useTooltip';

export default function NotificationsPopover() {
	const investorService = new InvestorService();

	const [becomeProCount, setBecomeProCount] = useState(0);
	const [passportExpiryCount, setPassportExpiryCount] = useState(0);
	const [annualReviewCount, setAnnualReviewCount] = useState(0);
	const [pendingIbanCount, setPendingIbanCount] = useState(0);

	const checkIfNumber = (value) => {
		return isNaN(value) ? 0 : value;
	};

	const getAllCount = () => {
		if (checkPermissions(RolesTypes.Investors)) {
			investorService.investorBecomeProCount().then((resp) => {
				setBecomeProCount(checkIfNumber(resp.data));
			});
			investorService
				.getAnnualReviewCount(InvestorStatuses.Pending)
				.then((resp) => {
					setAnnualReviewCount(checkIfNumber(resp.data));
				});
			investorService.getPassportExpiryCount().then((resp) => {
				setPassportExpiryCount(checkIfNumber(resp.data));
			});
			investorService.getPendingIbanCount().then((resp) => {
				setPendingIbanCount(checkIfNumber(resp.data));
			});
		}
	};

	useEffect(() => {
		getAllCount();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const notificationButtons = [
		{
			key: 'annualReview',
			label: 'Annual Review Date',
			icon: <PreviewIcon className="!text-white" />,
			count: annualReviewCount,
			url: `${AppRoutes.Investor}/${AppRoutes.IAll}`,
			params: 'HasPassedAnnualReviewDate=true',
		},
		{
			key: 'windDown',
			label: 'Wind down',
			icon: <HourglassBottomIcon className="!text-white" />,
			count: passportExpiryCount,
			url: `${AppRoutes.Investor}/${AppRoutes.IAll}`,
			params: 'HasPassportExpired=true',
		},
		{
			key: 'proInvestors',
			label: 'Pro Investors',
			icon: <ManageAccountsIcon className="!text-white" />,
			count: becomeProCount,
			url: `${AppRoutes.Investor}/${AppRoutes.Iapproved}`,
			params: `?becameProInvestorRequestStatus=${BecomeProStatuses.Requested}`,
		},
		{
			key: 'pendingIbans',
			label: 'Pending IBANs',
			icon: <AccountBalanceIcon className="!text-white" />,
			count: pendingIbanCount,
			url: `${AppRoutes.Investor}/${AppRoutes.IAll}`,
			params: 'HasPendingIban=true',
		},
	];

	// Smaller, neater badge than the MUI default so it reads as an accent dot
	// rather than a heavy chip on the flat green bar.
	const badgeSx = {
		'& .MuiBadge-badge': {
			fontSize: '0.625rem',
			height: 16,
			minWidth: 16,
			padding: '0 4px',
		},
	};

	return (
		<>
			{checkPermissions(RolesTypes.Investors)
				? notificationButtons.map((item) => (
						<TooltipWrapper
							key={item.key}
							text={item.label}
							child={
								<IconButton
									component={RouterLink}
									to={{
										pathname: buildRegionizeRoute(item.url),
										search: item.params,
									}}
									aria-label={item.label}
									className="!text-white hover:!bg-white/20"
									sx={{ width: 35, height: 35 }}>
									<Badge
										max={99999}
										badgeContent={item.count}
										color="error"
										sx={badgeSx}>
										{item.icon}
									</Badge>
								</IconButton>
							}></TooltipWrapper>
				  ))
				: null}
		</>
	);
}
